import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import InvoicesDesktop from './InvoicesDesktop';
import { IInitialState } from 'src/store/initialState';
import {
  authorizedSel,
  trackingNumberSel,
  errorMessageSel,
  isPendingSel,
  showStatusModalSel,
  errorSel,
  paySimpleActions as paySimplePaymentActions
} from 'src/store/modules/paysimplepayment';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import actions from 'src/store/modules/invoices/actions';
import {
  statusFilterSel,
  orderFilterSel,
  invoiceFilterSel,
  nardFilterSel,
  orderNumberFilterSel,
  poNumberFilterSel
} from 'src/store/modules/invoices';
const mapStateToProps = (state: IInitialState) => ({
  authorized: authorizedSel(state),
  trackingNumber: trackingNumberSel(state),
  errorMessage: errorMessageSel(state),
  isPendingPayment: isPendingSel(state),
  showStatusModal: showStatusModalSel(state),
  errorPayment: errorSel(state),
  statusFilter: statusFilterSel(state),
  orderFilter: orderFilterSel(state),
  invoiceFilter: invoiceFilterSel(state),
  nardFilter: nardFilterSel(state),
  orderNumberFilter: orderNumberFilterSel(state),
  poNumberFilter: poNumberFilterSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  closeStatusModal: () => {
    dispatch(paySimplePaymentActions.closeStatusModal());
  },
  getInvoices: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(actions.getInvoices(filters, pagination))
});

export const pureComponent = InvoicesDesktop;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(InvoicesDesktop));
